<template>
  <div class="to-top">
    <img src="@/assets/img/common/top.png">
  </div>
</template>

<script>
export default {
  name: '',
  data() {
    return {

    }
  },
  components: {

  }
}
</script>

<style scoped>
.to-top {
  position: fixed;
  bottom: 50px;
  right: 5px;
}
.to-top img {
  height: 45px;
  width: 45px;
}
</style>
